// extracted by mini-css-extract-plugin
export default {"container":"dashboardSideNav_container__1OGvz","tabItem":"dashboardSideNav_tabItem__VapoI","active":"dashboardSideNav_active__jolZX"};